import _createClass from "/Users/elias/Desktop/Bureau/DocUp - vide\u0301o/Site Web /Superprops copie/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/Users/elias/Desktop/Bureau/DocUp - vide\u0301o/Site Web /Superprops copie/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
export var Point = /*#__PURE__*/_createClass(function Point(position, particle) {
  _classCallCheck(this, Point);

  this.position = position;
  this.particle = particle;
});